import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const ParkingDamageExcess = (props) => {
  return (
    <FormGroup controlId="parkingDamageExcess">
      <Col componentClass={ControlLabel} sm={5}>
        Parking Damage Excess (HKD)
      </Col>
      <Col sm={7}>
          <FormControl
            type="text"
            autoComplete="off"
            maxLength="60"
            value={props.parkingDamageExcess}
            onChange={props.handleChangeParkingDamageExcess}
          />
      </Col>
    </FormGroup>
  )
}

ParkingDamageExcess.propTypes = {
  parkingDamageExcess: PropTypes.string,
  handleChangeParkingDamageExcess: PropTypes.func
};

export default ParkingDamageExcess;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/parkingDamageExcess/ParkingDamageExcess.js